import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export default function CopyButton({ text, label = "Text", testid }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    const value = (text || "").toString();
    if (!value.trim()) {
      toast.error("Nothing to copy yet");
      return;
    }
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success(`${label} copied`);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={copy}
      title={`Copy ${label.toLowerCase()}`}
      className="flex items-center gap-1 rounded px-1.5 py-0.5 text-[#9ca3af] transition-colors hover:bg-[#1d2028] hover:text-[#00e5ff]"
    >
      {copied ? <Check className="h-3.5 w-3.5 text-[#00e5ff]" /> : <Copy className="h-3.5 w-3.5" />}
    </button>
  );
}
